import { useRef, useState } from "react";
import { Volume2, VolumeX, Play, Pause } from "lucide-react";

export default function VideoPlayer({ src, label, tag, className = "", fit = "cover" }) {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);
  const [paused, setPaused] = useState(false);

  const toggleSound = (e) => {
    e.stopPropagation();
    const v = ref.current;
    if (!v) return;
    v.muted = !v.muted;
    setMuted(v.muted);
    if (!v.muted) v.play();
  };
  const togglePlay = () => {
    const v = ref.current;
    if (!v) return;
    if (v.paused) { v.play(); setPaused(false); } else { v.pause(); setPaused(true); }
  };

  return (
    <div className={`group relative overflow-hidden rounded-3xl border border-white/10 bg-black ${className}`}>
      <video ref={ref} src={src} autoPlay loop muted playsInline onClick={togglePlay}
        className={`h-full w-full cursor-pointer object-${fit}`} />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/10" />

      {tag && (
        <span className="absolute left-4 top-4 rounded-full gold-gradient px-3 py-1 font-oswald text-[10px] font-semibold uppercase tracking-[0.12em] text-black">
          {tag}
        </span>
      )}
      <button onClick={toggleSound} aria-label="Toggle sound"
        className="absolute right-4 top-4 z-10 grid h-10 w-10 place-items-center rounded-full glass text-cream transition-transform hover:scale-110 hover:text-gold">
        {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
      </button>
      <button onClick={togglePlay} aria-label="Play or pause"
        className="absolute bottom-4 right-4 z-10 grid h-10 w-10 place-items-center rounded-full glass text-cream opacity-0 transition-opacity group-hover:opacity-100">
        {paused ? <Play size={16} fill="currentColor" /> : <Pause size={16} />}
      </button>

      {label && (
        <span className="absolute bottom-5 left-5 z-10 max-w-[80%] font-oswald text-base uppercase leading-tight tracking-wide text-cream sm:text-lg">
          {label}
        </span>
      )}
    </div>
  );
}
